import {IOrganization} from "./organization.model";

export interface IPhoneType {
  id?: number;
  itemName?: string;
  status?: string;
  description?: string;
  organization?: IOrganization;

}

export class PhoneType implements IPhoneType {
  constructor(public id?: number, public itemName?: string, public status?: string, public description?: string
,  public organization?: IOrganization
) {
}
}
